import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';

const PaymentSuccessPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center max-w-md px-6">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" strokeWidth={1.5} />
        </div>
        <h1 className="text-3xl font-heading font-bold text-[#0A2342] mb-4">
          Payment Successful!
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Thank you for your purchase. Your order has been confirmed and will be processed shortly.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/dashboard">
            <Button 
              className="bg-[#0A2342] text-white hover:bg-[#0A2342]/90"
              data-testid="view-orders-btn"
            >
              View Orders
            </Button>
          </Link>
          <Link to="/products">
            <Button 
              variant="outline"
              data-testid="continue-shopping-btn"
            >
              Continue Shopping
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;